import { render, staticRenderFns } from "./cModalGenerarFacturaOs.vue?vue&type=template&id=6486d94b&scoped=true"
import script from "./cModalGenerarFacturaOs.vue?vue&type=script&lang=js"
export * from "./cModalGenerarFacturaOs.vue?vue&type=script&lang=js"
import style0 from "./cModalGenerarFacturaOs.vue?vue&type=style&index=0&id=6486d94b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6486d94b",
  null
  
)

export default component.exports